import { Helmet } from 'react-helmet-async'
import { AboutUs } from '../components/sections/AboutUs'
import { ChooseUs } from '../components/sections/ChooseUs'
import { ClientWords } from '../components/sections/ClientWords'
import { ContactUs } from '../components/sections/ContactUs'
import { Landing } from '../components/sections/Landing'
import { Partners } from '../components/sections/Partners'
import { Services } from '../components/sections/Services'
export const Home = () => {
  return (
    <>
      <Helmet title="Home" />
      <Landing />
      <AboutUs />
      <ChooseUs />
      <Services />
      <Partners />
      <ClientWords />
      <ContactUs />
    </>
  )
}

export default Home
